/**
 * Generic multi-select dropdown — `[data-hn-multiselect]`.
 *
 * Markup: button.toggle + popover z listą checkboxów. Wartości
 * trzymają natywne <input type="checkbox">, więc form submit jest standardowy.
 *
 * Label przycisku aktualizuje się automatycznie:
 *   0 zaznaczone  → placeholder z data-placeholder
 *   1             → wybrana etykieta
 *   2–4 (few PL)  → "N etykiety" (data-summary-few z %d)
 *   5+ (many PL)  → "N etykietów" (data-summary-many)
 */

function pluralPL(n, singular, few, many) {
    const abs = Math.abs(n);
    const mod10 = abs % 10;
    const mod100 = abs % 100;
    if (abs === 1) return singular;
    if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return few;
    return many;
}

function updateLabel(root) {
    const labelEl = root.querySelector('[data-hn-multiselect-label]');
    if (!labelEl) return;
    const checked = root.querySelectorAll('input[type="checkbox"]:checked');
    const placeholder = root.dataset.placeholder || '';
    const singular = root.dataset.summarySingular || '%d wybrane';
    const few = root.dataset.summaryFew || '%d wybrane';
    const many = root.dataset.summaryMany || '%d wybranych';

    if (checked.length === 0) {
        labelEl.textContent = placeholder;
        root.classList.remove('hn-multiselect--has-selection');
        return;
    }
    if (checked.length === 1) {
        const text = checked[0].closest('label')?.querySelector('.hn-multiselect__option-label')?.textContent?.trim();
        labelEl.textContent = text || (singular.replace('%d', '1'));
    } else {
        const tpl = pluralPL(checked.length, singular, few, many);
        labelEl.textContent = tpl.replace('%d', String(checked.length));
    }
    root.classList.add('hn-multiselect--has-selection');
}

function setOpen(root, open) {
    const toggle = root.querySelector('[data-hn-multiselect-toggle]');
    const popover = root.querySelector('[data-hn-multiselect-popover]');
    if (!toggle || !popover) return;
    popover.hidden = !open;
    toggle.setAttribute('aria-expanded', String(open));
    root.classList.toggle('is-open', open);
}

function initOne(root) {
    if (root.dataset.hnMultiselectInit === '1') return;
    root.dataset.hnMultiselectInit = '1';

    const toggle = root.querySelector('[data-hn-multiselect-toggle]');
    const popover = root.querySelector('[data-hn-multiselect-popover]');
    if (!toggle || !popover) return;

    toggle.addEventListener('click', (event) => {
        event.stopPropagation();
        setOpen(root, popover.hidden);
    });

    // Zmiana checkboxa → odśwież label, NIE zamykaj (multi-select).
    root.addEventListener('change', (event) => {
        if (event.target.matches('input[type="checkbox"]')) {
            updateLabel(root);
        }
    });

    // Klik poza komponentem → zamknij.
    document.addEventListener('click', (event) => {
        if (!root.contains(event.target)) {
            setOpen(root, false);
        }
    });

    // Escape → zamknij i przywróć focus na przycisku.
    root.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !popover.hidden) {
            setOpen(root, false);
            toggle.focus();
        }
    });

    updateLabel(root);
}

export function initMultiselect() {
    document.querySelectorAll('[data-hn-multiselect]').forEach(initOne);
}
